/* Nakama · euro amounts written in texts (policies, FAQ, banners...) shown in the customer's currency (Javier 30/09).
   Prices drawn by Liquid (| money) are already converted by Shopify. This converts amounts typed by hand in content,
   like "4,90 €", "75 €" or "4,90<em>€</em>", with Shopify.currency.rate and NK.formatMoney (same format as the rest of the site).
   Round amounts stay round ("75 €" -> "$87"), same rule as the free shipping bar in the cart.
   Does nothing when the customer shops in EUR. Skip an element with data-nk-noconv. */
(function () {
  var S = window.Shopify && window.Shopify.currency;
  var rate = S && Number(S.rate);
  if (!S || !rate || !S.active || S.active === 'EUR' || !window.NK || !NK.formatMoney) return;

  var NUM = '(\\d{1,3}(?:[.,\\u00a0\\u202f ]\\d{3})+(?:[.,]\\d{1,2})?|\\d+(?:[.,]\\d{1,2})?)';
  var RE = new RegExp('€\\s?' + NUM + '|' + NUM + '\\s?€', 'g');
  var RE_END = new RegExp(NUM + '\\s*$');
  var SKIP = 'script,style,noscript,textarea,input,select,option,code,[contenteditable],[data-nk-noconv],.nk-perks,.nk-gift';

  function parse(s) {
    s = s.replace(/[   ]/g, '');
    var m = s.match(/[.,](\d{1,2})$/), whole = s, dec = '';
    if (m) { whole = s.slice(0, m.index); dec = m[1]; }
    whole = whole.replace(/[.,]/g, '');
    return Number(whole + (dec ? '.' + dec : ''));
  }
  function conv(s) {
    var eur = parse(s);
    if (!isFinite(eur)) return null;
    var round = eur % 1 === 0;
    var cents = round ? Math.round(eur * rate) * 100 : Math.round(eur * 100 * rate);
    return NK.formatMoney(cents, round);
  }
  function skip(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    return !el || !!el.closest(SKIP);
  }

  /* "4,90<em>€</em>": number in a text node, symbol in its own small element */
  function splitSymbol(el) {
    if (el._nkc || el.children.length || el.textContent.trim() !== '€' || skip(el)) return;
    var prev = el.previousSibling;
    if (!prev || prev.nodeType !== 3) return;
    var m = prev.nodeValue.match(RE_END);
    if (!m) return;
    var f = conv(m[1]);
    if (!f) return;
    var n = f.match(/\d[\d.,'   ]*\d|\d/);
    if (!n) return;
    var pre = f.slice(0, n.index).trim(), post = f.slice(n.index + n[0].length).trim();
    el._nkc = 1;
    var start = prev.nodeValue.length - m[0].length;
    if (post) {
      prev.nodeValue = prev.nodeValue.slice(0, start) + n[0];
      el.textContent = post;
    } else {
      /* prefix symbol ($, £, ¥...): move the small symbol before the number */
      var tail = prev.splitText(start);
      tail.nodeValue = n[0];
      el.textContent = pre;
      prev.parentNode.insertBefore(el, tail);
      el.style.marginRight = '.04em';
    }
  }

  function textNode(t) {
    var v = t.nodeValue;
    if (v.indexOf('€') < 0 || skip(t)) return;
    var out = v.replace(RE, function (all, a, b) {
      var f = conv(a || b);
      return f || all;
    });
    if (out !== v) t.nodeValue = out;
  }

  function run(root) {
    if (!root || skip(root)) return;
    if (root.nodeType === 3) { textNode(root); return; }
    if (root.nodeType !== 1) return;
    if (root.textContent.indexOf('€') < 0) return;
    var els = root.querySelectorAll('em,span,small,sup,i,b');
    for (var i = 0; i < els.length; i++) splitSymbol(els[i]);
    splitSymbol(root);
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(textNode);
  }

  function start() {
    run(document.body);
    var q = [], t;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') q.push(m.target);
        else m.addedNodes.forEach(function (x) { q.push(x); });
      });
      clearTimeout(t);
      t = setTimeout(function () { var l = q; q = []; l.forEach(run); }, 30);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
